import React, {useState, useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux';
import * as RouterActions from '../../../actions/RouterActions';
import { Form } from 'semantic-ui-react'

var moment = require('moment');
require('moment/locale/de');

export function Dateselect(props){

    const [date, setDate] = useState(null);

    useEffect(() => {
        if(typeof props.date === 'undefined' || !props.date.match(/^\d{4}\-\d{2}\-\d{2}$/)){
            setDate(moment().startOf('day').format('YYYY-MM-DD'));
        }else{
            setDate(props.date);
        }
    }, [props.date]);

    if(date === null)return null;

    return (
        <div style={{
            margin: '0.5em'
        }}>
            <Form>
                <Form.Field inline label='Datum:' control='input' type='date' value={date} onChange={(e) => {
                    props.onDateChange(e.target.value);
                }} />
            </Form>
        </div>
    )
}